// extracted by mini-css-extract-plugin
export default {"updateMessage":"PJ5QMfP4L8kO5Hwe5kQy","form":"aZypQI99O64uTX8brS3Z"};